import { CloseOutlined, MenuOutlined } from "@ant-design/icons"

interface MenuButtonProps {
    onClick: () => void;
    collapsed: boolean;
}

export const MenuButton: React.FC<MenuButtonProps> = ({ onClick, collapsed }) => {
    return (
        <button onClick={onClick} className="flex items-center justify-center w-8 h-8 text-white text-2xl focus:outline-none">
            {collapsed ? <MenuOutlined /> : <CloseOutlined />}
        </button>
    )
}

//<Button type="text" color="white" icon={<MenuOutlined className='text-white' />} onClick={() => setMenuOpened(!menuOpened)}/>